import { Grid } from '@mui/material';
import React, { useContext, useState } from 'react'
import styles from '../../../../../assets/styles/componentStyles/manychatStyles/workflowFormComponents/workflowForm.module.scss'
import fieldStyles from '../../../../../assets/styles/componentStyles/manychatStyles/workflowFormComponents/workflowCreate.module.scss'
import globalStyles from '../../../../../assets/styles/global.module.scss'
import workflowStyles from "../../../../../assets/styles/componentStyles/manychatStyles/workflowFormComponents/workflowGlobal.module.scss"
import { WorkflowContext, WorkflowContextPayload } from '../../../../../context/workflowContext';
import { IntegrationContext, IntegrationContextPayload } from '../../../../../context/integrationContext';
import { chatbotIntegratedChannelDeploymentInstagramObj, chatbotIntegratedChannelDeploymentObj, metaIntegrationFaceBookDataNew, metaIntegrationWhatsAppDataNew, metaIntegrationWhatsappPhoneNumberData, metIntegrationInstagramDataNew } from '../../../../../models/axiosModel';
import { UserContext, UserContextPayload } from '../../../../../context/userContext';
import { getChatbotVersionInfo, isCurrentViewVersionPublished } from '../../utilityFunctions';
import ChatbotExceptionNew from './chatbotExceptionNew';
import { handleHeaderDesignOfLeftSection, handleLeftPanel } from '../../flowBuilderConstants';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import { FlowBuilderContext, FlowBuilderContextPayload } from '../../../../../context/flowBuilderContext';
import SmartDelay from './smartDelay';
import { isWhatsAppIntegration } from '../../../../../pages/ruleBasedInbox/utils';
import { isInstagramChannel, isWhatsAppChannel } from '../../../../../pages/ruleBasedInbox/channelConstants';

const BasicWorkflowDetails = () => {
    
    const { workflowIntegrationList, currentActiveStaticWorkflow } = useContext(WorkflowContext) as WorkflowContextPayload;
    const { integrationListNewStructure } = useContext(IntegrationContext) as IntegrationContextPayload;
    const { userDetail } = useContext(UserContext) as UserContextPayload

    const whatsAppChannel = currentActiveStaticWorkflow?.chatbot_integrated_channel_deployment?.integrated_channel_data?.[0] as chatbotIntegratedChannelDeploymentObj | undefined;
    const instagramChannel = currentActiveStaticWorkflow?.chatbot_integrated_channel_deployment?.integrated_channel_data?.[0] as chatbotIntegratedChannelDeploymentInstagramObj | undefined;

    const [selectedWBA] = useState<chatbotIntegratedChannelDeploymentObj | null>(whatsAppChannel || null);
    const [selectedPhoneNumber] = useState<metaIntegrationWhatsappPhoneNumberData | null>(whatsAppChannel?.meta_integration_whatsapp_phone_number_data?.[0] || null);
    const [selectedIGAccount] = useState<chatbotIntegratedChannelDeploymentInstagramObj | null>(instagramChannel || null);
    
    const { currentActiveNodeConfig, setCurrentActiveNodeConfig } = useContext(FlowBuilderContext) as FlowBuilderContextPayload

    const getWhatsAppNumberOptions = () => {
        if (!integrationListNewStructure) return [];

        return integrationListNewStructure.filter(isWhatsAppIntegration)
            .find((waba: metaIntegrationWhatsAppDataNew) => waba.waba_id == selectedWBA?.waba_id)
            ?.meta_integration_phone_number_data || [];
    }

    const getWhatsAppNumberValue = () => {
        const options = getWhatsAppNumberOptions();
        return options.find((phoneNumberData: any) => phoneNumberData.meta_integration_whatsapp_phone_number_id === selectedPhoneNumber?.meta_integration_whatsapp_phone_number_id) || null;
    }

    const getDeploymentChannelName = () => {
        return workflowIntegrationList?.find((option) => option.channel_id === Number(currentActiveStaticWorkflow?.chatbot_channel?.channel_id))?.channel_name ?? "-";
    }

    const deploymentChannelName = currentActiveStaticWorkflow?.chatbot_channel?.channel_name;
    const isWhatsApp = isWhatsAppChannel(deploymentChannelName);
    const isInstagram = isInstagramChannel(deploymentChannelName);

    return (
        <Grid item> 
            <Grid container gap={1} direction={"column"}>
                
                <Grid item xs={12} className={`${styles.bodyFormHeadingStyle} ${styles.headerFormItemStyle} ${globalStyles.displayFlexStyle} ${globalStyles.justifyCenter} ${globalStyles.primaryFontSize} ${globalStyles.primaryFontWeight}`} 
                    sx={{ 
                        backgroundColor: handleHeaderDesignOfLeftSection(getDeploymentChannelName().toLowerCase()),
                        position: "relative",     
                    }}>
                        {currentActiveNodeConfig.flagOpenConfigForm && 
                            <Grid item className={`${globalStyles.clickable} ${workflowStyles.leftSectionArrowIconForOpenGrid}`} onClick={() => handleLeftPanel(setCurrentActiveNodeConfig)}>
                                <ArrowBackIosNewIcon className={workflowStyles.leftSectionArrowIconForOpen} sx={{ transform: currentActiveNodeConfig.flagOpenConfigForm ? "" : "rotate(180deg)", }} />
                            </Grid>
                        }
                    Chatbot Details
                </Grid>

                <Grid item xs={12} className={styles.bodyFormComponents} direction={"column"} gap={3}>
                    <Grid container direction={"column"} gap={3}>
                        
                        <Grid item sx={{ width: "100%" }}>
                            <Grid container justifyContent={"space-between"} gap={"10px"}>
                                <Grid item className={fieldStyles.createWorkflowLabelStyle}>
                                    Chatbot Name
                                </Grid>

                                <Grid item className={globalStyles.primaryFontSize}>
                                    {currentActiveStaticWorkflow?.chatbot_name}
                                </Grid>
                            </Grid>
                        </Grid>

                        <Grid item sx={{ width: "100%" }}>
                            <Grid container justifyContent={"space-between"} gap={"10px"}>
                                <Grid item className={fieldStyles.createWorkflowLabelStyle}>
                                    Published Status
                                </Grid>

                                <Grid item className={`${getChatbotVersionInfo(currentActiveStaticWorkflow, userDetail).status == "Published" ? fieldStyles.publishedStatus : fieldStyles.draftStatus} ${globalStyles.primaryFontSize}`}>
                                    {getChatbotVersionInfo(currentActiveStaticWorkflow, userDetail).status}
                                </Grid>
                            </Grid>
                        </Grid>

                        {getChatbotVersionInfo(currentActiveStaticWorkflow, userDetail).status == "Published" &&
                            <Grid item sx={{ width: "100%" }}>
                                <Grid container justifyContent={"space-between"} gap={"10px"}>
                                    <Grid item className={fieldStyles.createWorkflowLabelStyle}>
                                        Last Published On
                                    </Grid>

                                    <Grid item className={globalStyles.primaryFontSize}>
                                        {getChatbotVersionInfo(currentActiveStaticWorkflow, userDetail).lastPublishedTimestamp}
                                    </Grid>
                                </Grid>
                            </Grid>
                        }

                        <Grid item sx={{ width: "100%" }}>
                            <Grid container justifyContent={"space-between"} gap={"10px"}>
                                <Grid item className={fieldStyles.createWorkflowLabelStyle}>
                                    Deployment Channel
                                </Grid>

                                <Grid item className={globalStyles.primaryFontSize}>
                                    {getDeploymentChannelName()}
                                </Grid>
                            </Grid>
                        </Grid>

                        <Grid item sx={{ width: "100%" }}>
                            <Grid container justifyContent={"space-between"} gap={"10px"}>
                                <Grid item className={fieldStyles.createWorkflowLabelStyle}>
                                    {isInstagram ? "Instagram" : "WhatsApp"} Business Account 
                                </Grid>

                                <Grid item className={globalStyles.primaryFontSize}>
                                    {isInstagram 
                                        ? (selectedIGAccount?.instagram_account_name ?? "-") 
                                        : (selectedWBA?.waba_name ?? "-")
                                    }
                                </Grid>
                            </Grid>
                        </Grid>

                        {isWhatsApp && (
                            <Grid item sx={{ width: "100%" }}>
                                <Grid container justifyContent={"space-between"} gap={"10px"}>
                                    <Grid item className={fieldStyles.createWorkflowLabelStyle}>
                                        WhatsApp Business Phone Number
                                    </Grid>

                                    <Grid item className={globalStyles.primaryFontSize}>
                                        {getWhatsAppNumberValue()?.display_phone_number ?? "-"}

                                    </Grid>
                                </Grid>
                            </Grid>
                        )}

                        {isInstagram && (
                            <Grid item sx={{ width: "100%" }}>
                                <Grid container justifyContent={"space-between"} gap={"10px"}>
                                    <Grid item className={fieldStyles.createWorkflowLabelStyle}>
                                        Instagram Account ID
                                    </Grid>

                                    <Grid item className={globalStyles.primaryFontSize}>
                                        {selectedIGAccount?.instagram_account_id ?? "-"}

                                    </Grid>
                                </Grid>
                            </Grid>
                        )}

                        <Grid item sx={{ width: "100%" }}>
                            <Grid container justifyContent={"space-between"} gap={"10px"}>
                                <Grid item className={fieldStyles.createWorkflowLabelStyle}>
                                    Content Type
                                </Grid>

                                <Grid item className={globalStyles.primaryFontSize}>
                                    {currentActiveStaticWorkflow?.chatbot_integrated_channel_deployment?.deployment_channel_content_type_data.channel_content_type_name ?? "-"}
                                </Grid>
                            </Grid>
                        </Grid>

                        {/* <ChatbotException /> */}  
                        {isCurrentViewVersionPublished(currentActiveStaticWorkflow) && 
                            <ChatbotExceptionNew />
                        }

                        {isWhatsApp &&
                            <SmartDelay
                                flagStepLevel={false}
                            />
                        }
                    </Grid>
                </Grid>

            </Grid>
        </Grid>
    )
}

export default BasicWorkflowDetails
